import React, { useEffect, useState } from "react";
import "../Style/Pages/Account.css";
import Profile from "../Component/Profile";
import Personalinfo from "../Component/Personalinfo";
import { useDispatch, useSelector } from "react-redux";
import { getWithTokenAPI } from "../Util/Api";
import { setProfile } from "../Store/ProfileSlicer";
import { ProfilePageSkeleton } from "../Component/Skeleton";
const Account = () => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const token = auth.token;
  const adminId = auth.userId;
  const [accountdetails, setAccountdetails] = useState({});
  const [reload, setReload] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchaccountdetails = async () => {
      try {
        setLoading(true);
        const response = await getWithTokenAPI(
          token,
          `/user/profile/${adminId}`,
        );
        setAccountdetails(response?.data);
        dispatch(setProfile(response?.data));
      } catch {
        console.log("Error in fetching Limit Api");
      } finally {
        setLoading(false);
      }
    };
    fetchaccountdetails();
  }, [token, reload]);
  if (loading) return <ProfilePageSkeleton />;
  return (
    <div className="accountpage">
      <Profile profiledata={accountdetails} />
      <Personalinfo
        profiledata={accountdetails}
        onApproveSuccess={() => setReload((p) => p + 1)}
      />
    </div>
  );
};

export default Account;
